import React, { useEffect, useState, useRef, useMemo } from 'react';
import './metricLoader.css';
import {
  TextField,
  InputAdornment,
  FormControlLabel,
  RadioGroup,
  FormLabel,
  Radio,
  Box,
} from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import axios from 'axios';
import { useMutation, useQuery } from '@tanstack/react-query';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import PeopleIcon from '@mui/icons-material/People';
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';
import InventoryIcon from '@mui/icons-material/Inventory';
import OutboundIcon from '@mui/icons-material/Outbound';
import WorkIcon from '@mui/icons-material/Work';
import CheckIcon from '@mui/icons-material/Check';
import SafetyCheckIcon from '@mui/icons-material/SafetyCheck';
import DesignServicesIcon from '@mui/icons-material/DesignServices';
import PublicIcon from '@mui/icons-material/Public';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';
import ControlCameraIcon from '@mui/icons-material/ControlCamera';
import DownloadingIcon from '@mui/icons-material/Downloading';
import HourglassTopIcon from '@mui/icons-material/HourglassTop';
import NewSideCube from '../Cube/NewSideCube';
import ElectricBoltIcon from '@mui/icons-material/ElectricBolt';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import DatasetIcon from '@mui/icons-material/Dataset';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import ThumbUpOffAltIcon from '@mui/icons-material/ThumbUpOffAlt';
import SpeedIcon from '@mui/icons-material/Speed';
import { Link } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import ArticleIcon from '@mui/icons-material/Article';
import HelpIcon from '@mui/icons-material/Help';
import DateRangeIcon from '@mui/icons-material/DateRange';

function MetricLoader({ plant, user, countMetrics, countRCAs }) {
  axios.defaults.withCredentials = true;
  const host = window.location.hostname;

  // Date Calculation Info ----------------------------------------------------------------------------------------------------------------------
  const date = new Date();
  const isFirstDay = date.getDate() === 1;
  let day = date.getDate();
  let month = date.getMonth() + 1;
  let year = date.getFullYear();
  let queryMonth = 0;

  if (month === 1) {
    year = year - 1;
    queryMonth = 12;
  } else if (month < 11) {
    queryMonth = '0' + (month - 1).toString();
  } else {
    queryMonth = month - 1;
  }

  const queryDate = `${year}-${queryMonth}-01`;
  const dateDict = {
    1: 'December',
    2: 'January',
    3: 'February',
    4: 'March',
    5: 'April',
    6: 'May',
    7: 'June',
    8: 'July',
    9: 'August',
    10: 'September',
    11: 'October',
    12: 'November',
  };

  //Get the most recent weekly date 
  // Get the most recent Sunday based on America/New_York calendar date
function getMostRecentSundayEastern(now = new Date(), weeksAgo = 1) {
  // Eastern "today" parts
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/New_York',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(now);

  const y = Number(parts.find((p) => p.type === 'year')?.value);
  const m = Number(parts.find((p) => p.type === 'month')?.value); // 1-12
  const d = Number(parts.find((p) => p.type === 'day')?.value);

  // Create a Date representing that Eastern calendar day (as UTC midnight)
  const easternDayUtc = new Date(Date.UTC(y, m - 1, d, 0, 0, 0));

  // Get weekday for that Eastern calendar day
  const dowStr = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/New_York',
    weekday: 'short',
  }).format(easternDayUtc);

  const map = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };

  easternDayUtc.setUTCDate(easternDayUtc.getUTCDate() - (map[dowStr] ?? 0));
  easternDayUtc.setUTCDate(easternDayUtc.getUTCDate() - 7 * weeksAgo);
  return easternDayUtc;
}


//Weekly date above ^

  function getBusinessDayNumber(year, month, dayOfMonth) {
    let businessDayNumber = 0;

    for (let day = 0; day < dayOfMonth; day++) {
      const date = new Date(year, month - 1, day + 1);
      const dayOfWeek = date.getDay();

      if (dayOfWeek !== 0 && dayOfWeek !== 6) {
        businessDayNumber++;
      }
    }

    return businessDayNumber;
  }

  const businessDayNumber = getBusinessDayNumber(year, month, day);

  // Posts and Gets ----------------------------------------------------------------------------------------------------------------------
  const getDbInfo = async () => {
    if (plant.length === 0) {
      return null;
    } else {
      const res = await axios.get(
        `https://api.${host}/db?plant=${plant}&date=${queryDate}`,
        { withCredentials: true }
      );
      console.log(res);
      setNewMetrics(res.data.sort((a, b) => a[0] - b[0]));
      return res;
    }
  };

  const sendServerInfo = async (element) => {
    const postRes = await axios.post(
      `https://api.${host}/dbpost`,
      {
        description: metrics[element].description,
        metric: metrics[element].metric,
        plant: plant,
        date: queryDate,
        user: user,
      },
      { withCredentials: true }
    );
    console.log(postRes);
    return postRes;
  };

  // NOTE: now respects % vs non-% metrics (for Subtract etc.)
  const sendServerInfoCalc = async (dict) => {
    const isPercent = dict.adorn === '%';
    const metricValue =
      dict.amount === ''
        ? ''
        : isPercent
        ? (dict.amount / 100).toFixed(4)
        : dict.amount;

    const postRes = await axios.post(
      `https://api.${host}/dbpost`,
      {
        description: dict.desc,
        metric: metricValue,
        plant: plant,
        date: queryDate,
        user: user,
      },
      { withCredentials: true }
    );
    console.log(postRes);
    return postRes;
  };

  const sendRCAInfo = async (element) => {
    console.log(element);
    const postRca = await axios.post(
      `https://api.${host}/rca`,
      {
        description: element,
        rca: metricRcaDict[element],
        plant: plant,
        date: queryDate,
      },
      { withCredentials: true }
    );
    console.log(postRca);
    return postRca;
  };

  const sendRCAActionInfo = async (element) => {
    console.log(element);
    const postRca = await axios.post(
      `https://api.${host}/action`,
      {
        description: element,
        rca: metricRcaActionDict[element],
        plant: plant,
        date: queryDate,
      },
      { withCredentials: true }
    );
    console.log(postRca);
    return postRca;
  };

  // Tanstack Queries ----------------------------------------------------------------------------------------------------------------------
  const dbQuery = useQuery({
    queryKey: ['metrics', plant, queryDate],
    queryFn: getDbInfo,
  });

  const postMutation = useMutation({
    mutationFn: sendServerInfo,
    onSuccess: () => {
      getDbInfo();
    },
  });

  const calcMutation = useMutation({
    mutationFn: sendServerInfoCalc,
    onSuccess: () => {
      getDbInfo();
    },
  });

  // We only post calculated metrics via an effect now
  const lastPostedCalcRef = useRef({});
  const pendingCalcPostsRef = useRef([]);

  const rcaMutation = useMutation({
    mutationFn: sendRCAInfo,
    onSuccess: () => {
      getDbInfo();
    },
  });

  const rcaActionMutation = useMutation({
    mutationFn: sendRCAActionInfo,
    onSuccess: () => {
      getDbInfo();
    },
  });

  // UseState Variables and Initial Dictionaries ----------------------------------------------------------------------------------------------------------------------
  const [newMetrics, setNewMetrics] = useState([]);
  const [currPlant, setCurrPlant] = useState('');
  const [currCategory, setCurrCategory] = useState(0);
  const [currYear, setCurrYear] = useState(year);
  const [numOfMetrics, setNumOfMetrics] = useState(0);
  const [numOfRcas, setNumOfRcas] = useState(0);
  const [totalMetCount, setTotalMetCount] = useState(0);

  const [isOpen, setIsOpen] = useState(true);

  const [disabled, setDisabled] = useState(false);
  let y = numOfRcas;
  let z = numOfMetrics;
  let t = totalMetCount;

  const mui = {
    Finance: <AttachMoneyIcon />,
    HR: <PeopleIcon />,
    HSE: <HealthAndSafetyIcon />,
    Inventory: <InventoryIcon />,
    Outbound: <OutboundIcon />,
    Productivity: <WorkIcon />,
    Quality: <CheckIcon />,
    Safety: <SafetyCheckIcon />,
    Service: <DesignServicesIcon />,
    Sustainability: <PublicIcon />,
    Transportation: <LocalShippingIcon />,
    Controls: <ControlCameraIcon />,
    SCLT_Weekly: <DateRangeIcon />,
  };

  const plantDictionary = {
    JP04: 'Kawasaki - Sankyu',
    Argent: 'Argentina',
    CN03: 'Wujiang - Boyol',
    CN10: 'Shanghai - TingTong LX',
    DE20: 'Weilbach',
    IT09: 'Liscate',
    KSA: 'KSA',
    NA61: '3OVO',
    NA65: 'DC 3PL Mexico',
    NA75: 'North Brunswick',
    PL05: 'Bielsko',
    Taiwan: 'Taiwan - Focus',
    8002: 'Brasil Goiania',
    8006: 'Brasil Duque de Caxias',
    TH05: 'Bangkok - LDS',
    CN18: 'Shanghai - Tingtong CB',
    AE02: 'Dubai UAE',
    AE03: 'JAFZA',
    AU10: 'Sydney - Linfox CB/LX',
    ES09: 'Barcelona',
    HK02: 'Hong Kong - Ceva',
    MY01: 'Malaysia Toll',
    NA29: 'Riverside',
    NA33: 'Catano',
    SG13: 'Singapore - Toll',
    DE21: 'Dueren',
    UK27: 'Bournemouth',
    NA53: 'Sanford',
    Korea: 'Korea',
    NA19: 'Sanford-Factory',
    NA21: 'Hunt Valley - Factory',
    C002: 'Granollers - Factory',
    CU05: 'Ashford - Factory',
    BRAF: 'Goiania - Factory',
    LF02: 'Chartres - Factory',
    MC147: 'Monaco - Factory',
    NA46: 'West Rock',
    SA01: 'Saudi Arabia',
    APAC: 'APAC',
    JP06: 'Senko',
    CN06: 'Wujiang',
    FASEN: 'Senador Carnedo',
    FAMON: 'Monaco',
    6005: 'Senador',
    ZA02: 'Cape Town'
  };

  const universalCalc = [];
  const convertCalc = [];
  const switchCalc = [];
  const subtractCalc = []; // NEW
  const universalCalcInpDict = {}; // description -> raw numeric string
  const universalAttributes = {}; // calc grouping -> { dividend, divisor }
  const calcGroupByMetric = {}; // metric description -> grouping id
  const universalCalcDict = {}; // description -> calculated display value

  const lowerGoals = [];
  const dispFive = [];
  const showDisabled = [];

  let x = 0;
  let total = 0;
  let rcaCount = 0;

  const containerRef = useRef(null);

  // Stoplight state
  const [currentColorIndex, setCurrentColorIndex] = useState(0);
  const colors = ['#AAFF00', '#FF7276', '#FFD580'];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentColorIndex((prevIndex) => (prevIndex + 1) % colors.length);
    }, 2000);
    return () => clearInterval(timer);
  }, [colors.length]);

  // Use Effect Hooks -------------------------------------------------------------------------------------------------------------------------
  useEffect(() => {
    setCurrYear(year);
  }, [month, year]);

  useEffect(() => {
    if (day > 31) {
      setDisabled(true);
    }
  }, [day]);

  // Functions -------------------------------------------------------------------------------------------------------------------------
  const handleClose = () => {
    setIsOpen(false);
  };

  function scrollToTop() {
    if (containerRef.current) {
      containerRef.current.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  }

  function updateCat(category) {
    let newCat = category.category;
    setCurrCategory(newCat);
    if (currCategory !== newCat) {
      Array.from(document.querySelectorAll('input')).forEach(
        (input) => (input.value = '')
      );
    }
    scrollToTop();
  }

  function moveCat(direction) {
    if (direction === 'plus') {
      let index = categoryArray.indexOf(currCategory);
      if (index + 1 < categoryArray.length) {
        updateCat({ category: categoryArray[index + 1] });
      } else {
        updateCat({ category: categoryArray[0] });
      }
    } else {
      let index = categoryArray.indexOf(currCategory);
      if (index - 1 > -1) {
        updateCat({ category: categoryArray[index - 1] });
      } else {
        updateCat({ category: categoryArray[categoryArray.length - 1] });
      }
    }
  }

  const handleBlur = (input) => (e) => {
    const element = input;
    if (metrics[element].description === input) {
      let numWithoutCommas = e.target.value.replace(/,/g, '');
      let metricWithoutCommas = metrics[element].metric
        .toString()
        .replace(/,/g, '');
      if (
        parseFloat(metricWithoutCommas) !== parseFloat(numWithoutCommas) &&
        metricWithoutCommas !== numWithoutCommas
      ) {
        if (numWithoutCommas.length < 15) {
          metrics[element].metric = numWithoutCommas;
          if (numWithoutCommas.length !== 0) {
            if (metrics[element].adorn === '%') {
              metrics[element].metric = (numWithoutCommas / 100).toFixed(4);
            }
          }

          postMutation.mutate(element);
        }

        let goalWithoutCommas = metrics[element].goal.replace(/,/g, '');
        let r12WithoutCommas = metrics[element].r12m.replace(/,/g, '');
        let metricEl = parseFloat(metrics[element].metric);
        let metricGoal = parseFloat(goalWithoutCommas);
        let metricR12 = parseFloat(r12WithoutCommas);

        if (lowerGoals.includes(metrics[element].description)) {
          if (metricEl > metricGoal) {
            metrics[element].error = true;
            metricErrorDict[metrics[element].description] = true;
            metrics[element].help = 'Populate RCA';
            metrics[element].disabled = false;
            if (
              metrics[element].rcaRoot.length < 1 ||
              metrics[element].rcaAction.length < 1
            ) {
              rcaCount += 1;
            }
          } else if (metrics[element].adorn === '%' && metricEl > 1) {
            metrics[element].help = 'Over 100 Error';
            metrics[element].error = true;
            metricErrorDict[metrics[element].description] = true;
          } else {
            metrics[element].error = false;
            metrics[element].help = ' ';
            metrics[element].disabled = true;
          }
        } else {
          if (metricEl < metricGoal) {
            metrics[element].error = true;
            metricErrorDict[metrics[element].description] = true;
            metrics[element].help = 'Populate RCA';
            metrics[element].disabled = false;
            if (
              metrics[element].rcaRoot.length < 1 ||
              metrics[element].rcaAction.length < 1
            ) {
              rcaCount += 1;
            }
          } else if (metrics[element].adorn === '%' && metricEl > 1) {
            metrics[element].help = 'Over 100 Error';
            metrics[element].error = true;
            metricErrorDict[metrics[element].description] = true;
          } else {
            metrics[element].error = false;
            metrics[element].help = ' ';
            metrics[element].disabled = true;
          }
        }

        if (Math.abs((metricEl - metricR12) / metricR12) * 100 >= 15) {
          metrics[element].help += ' -15% Deviation from 12 mth avg';
        }
      }
    }

    return {
      ...metrics,
    };
  };

  const handleChange = (input) => (e) => {
    metricDict[input] = e.target.value;
    const element = input;
    let metricString = metrics[element].description;
    if (metricString === input) {
      if (metrics[element].metric !== e.target.value) {
        if (e.target.value.length !== 0) {
          if (e.target.value === 'Yes') {
            metrics[element].metric = -1;
          } else if (e.target.value === 'No') {
            metrics[element].metric = 1;
          }

          postMutation.mutate(element);
        }

        let metricEl = parseFloat(metrics[element].metric);
        let metricGoal = '';
        if (metrics[element].goal === 'Yes') {
          metricGoal = -1;
        } else if (metrics[element].goal === 'No') {
          metricGoal = 1;
        }

        if (lowerGoals.includes(metrics[element].description)) {
          if (metricEl > metricGoal) {
            metrics[element].error = true;
            metricErrorDict[metrics[element].description] = true;
            metrics[element].help = 'Populate RCA';
            metrics[element].disabled = false;
            if (
              metrics[element].rcaRoot.length < 1 ||
              metrics[element].rcaAction.length < 1
            ) {
              rcaCount += 1;
            }
          } else {
            metrics[element].error = false;
            metrics[element].help = ' ';
            metrics[element].disabled = true;
          }
        } else {
          if (metricEl < metricGoal) {
            metrics[element].error = true;
            metricErrorDict[metrics[element].description] = true;
            metrics[element].help = 'Populate RCA';
            metrics[element].disabled = false;
            if (
              metrics[element].rcaRoot.length < 1 ||
              metrics[element].rcaAction.length < 1
            ) {
              rcaCount += 1;
            }
          } else {
            metrics[element].error = false;
            metrics[element].help = ' ';
            metrics[element].disabled = true;
          }
        }
      }
    }
  };

  const handleRcaBlur = (input) => (e) => {
    const str = `${e.target.value}`;
    let rcaRes = str.replace(/[^a-zA-Z0-9., ]/g, '');
    if (metricRcaDict[input] !== e.target.value) {
      if (e.target.value.length !== 0 && e.target.value.length < 500) {
        metricRcaDict[input] = rcaRes;
        rcaMutation.mutate(input);
      }
    }
  };

  const handleRcaActionBlur = (input) => (e) => {
    const str = `${e.target.value}`;
    let rcaRes = str.replace(/[^a-zA-Z0-9., ]/g, '');
    if (metricRcaActionDict[input] !== e.target.value) {
      if (e.target.value.length !== 0 && e.target.value.length < 500) {
        metricRcaActionDict[input] = rcaRes;
        rcaActionMutation.mutate(input);
      }
    }
  };

  //Weekly Header
 const weeklyHeader = useMemo(() => {
  if (currCategory !== 'SCLT_Weekly') return null;

  const start = getMostRecentSundayEastern(new Date());
  const end = new Date(start);
  end.setUTCDate(end.getUTCDate() + 6);

  const fmt = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/New_York',
    month: 'long',
    day: 'numeric',
  });

  const startParts = fmt.formatToParts(start);
  const endParts = fmt.formatToParts(end);

  const startMonth = startParts.find(p => p.type === 'month').value;
  const startDay   = startParts.find(p => p.type === 'day').value;
  const endDay     = endParts.find(p => p.type === 'day').value;

  const year = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/New_York',
    year: 'numeric',
  }).format(start);

  return `${startMonth} ${startDay}–${endDay}, ${year}`;
}, [currCategory]);


  // Initial render and subsequent rerender variables------------------------------------------------------------------------------------
  let categoryArray = [];
  let categoryCompleted = {};
  let nonCompleteCats = [];
  let missingMetsCat = {};
  let totalMetsCat = {};
  let metrics = {};
  let yesNo = [];
  let metricDict = {};
  let metricErrorDict = {};
  let metricLastDict = {};
  let metricHelpDict = {};
  let metricGoalDict = {};
  let metricAdornDict = {};
  let metricRcaDict = {};
  let metricRcaActionDict = {};
  let metricDisabled = {};
  let metricMultiLine = {};
  let metricInfoDict = {};
  let metricR12Dict = {};
  let acceptable = [
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '.',
    ',',
    '-',
  ];

  console.log('rendered metricLoader');

  if (plant !== currPlant) {
    getDbInfo();
    setCurrPlant(plant);
    setCurrCategory(0);
    Array.from(document.querySelectorAll('input')).forEach(
      (input) => (input.value = '')
    );
  }

  // Build metrics + calc structures from DB rows -------------------------------------------------------
  for (let element in newMetrics) {
    let currentMetric = newMetrics[element];

    if (currentMetric[7] === undefined || currentMetric[7] === null) {
      currentMetric[7] = '';
    }
    if (currentMetric[8] === undefined || currentMetric[8] === null) {
      currentMetric[8] = '';
    }
    if (currentMetric[13] === undefined || currentMetric[13] === null) {
      currentMetric[13] = '';
    }
    if (currentMetric[19] === undefined || currentMetric[19] === null) {
      currentMetric[19] = '';
    }
    if (currentMetric[20] === undefined || currentMetric[20] === null) {
      currentMetric[20] = '';
    }
    if (currentMetric[21] === undefined || currentMetric[21] === null) {
      currentMetric[21] = '';
    }
    if (currentMetric[22] === undefined || currentMetric[22] === null) {
      currentMetric[22] = '';
    }
    if (currentMetric[24] === undefined || currentMetric[24] === null) {
      currentMetric[24] = '';
    }
    if (currentMetric[25] === undefined || currentMetric[25] === null) {
      currentMetric[25] = '';
    }
    if (currentMetric[27] === undefined || currentMetric[27] === null) {
      currentMetric[27] = '';
    }
    if (currentMetric[28] === undefined || currentMetric[28] === null) {
      currentMetric[28] = '';
    }
    if (currentMetric[6] === undefined || currentMetric[6] === null) {
      currentMetric[6] = 'NotRealMetric';
    }

    let key = currentMetric[6];

    metrics[key] = {
      order: currentMetric[0],
      plant: currentMetric[4],
      plantName: currentMetric[5],
      category: currentMetric[10],
      description: currentMetric[6],
      metric: currentMetric[7],
      lastMetric: currentMetric[8],
      adorn: currentMetric[12],
      error: 'false',
      help: ' ',
      info: `Data Source: ${currentMetric[15]} || Definition: ${currentMetric[16]}`,
      rcaRoot: currentMetric[24],
      rcaAction: currentMetric[25],
      goal: currentMetric[13],
      siteUser: currentMetric[27],
      r12m: currentMetric[28],
      disabled: true,
    };

    if (currentMetric[12] === 'Yes/No') {
      yesNo.push(currentMetric[6]);
      if (currentMetric[7] === '-1' || currentMetric[7] === -1) {
        metrics[key].metric = 'Yes';
      }
      if (
        currentMetric[13] === '-1' ||
        currentMetric[13] === '-1.0' ||
        currentMetric[13] === -1 ||
        currentMetric[13] === -1.0
      ) {
        metrics[key].goal = 'Yes';
      }
      if (
        currentMetric[8] === '-1' ||
        currentMetric[8] === '-1.0' ||
        currentMetric[8] === -1 ||
        currentMetric[8] === -1.0
      ) {
        metrics[key].lastMetric = 'Yes';
      }

      if (currentMetric[7] === '1' || currentMetric[7] === 1) {
        metrics[key].metric = 'No';
      }
      if (currentMetric[8] === '1' || currentMetric[8] === 1) {
        metrics[key].lastMetric = 'No';
      }
      if (
        currentMetric[13] === '1' ||
        currentMetric[13] === '1.0' ||
        currentMetric[13] === 1
      ) {
        metrics[key].goal = 'No';
      }
    }

    if (currentMetric[14] === 'Over') {
      lowerGoals.push(currentMetric[6]);
    }

    if (currentMetric[12] === '%') {
      if (currentMetric[8] !== '') {
        metrics[key].lastMetric = currentMetric[8] * 100;
      }
      if (currentMetric[13] !== '') {
        metrics[key].goal = (currentMetric[13] * 100).toFixed(2);
      }
      if (currentMetric[7] !== '') {
        metrics[key].metric = (currentMetric[7] * 100).toFixed(2);
      }
      if (currentMetric[8] !== '') {
        metrics[key].lastMetric = (currentMetric[8] * 100).toFixed(2);
      }
      if (currentMetric[28] !== '') {
        metrics[key].r12m = (currentMetric[28] * 100).toFixed(2);
      }
    } else if (
      currentMetric[12] !== '%' &&
      currentMetric[12] !== 'Yes/No'
    ) {
      if (currentMetric[28] !== '') {
        let numNoCommas = currentMetric[28].toLocaleString('en-US', {
          style: 'decimal',
        });
        metrics[key].r12m = numNoCommas.replace(/\.\d*/, '');
      }
      if (currentMetric[7] !== '') {
        metrics[key].metric = currentMetric[7].toLocaleString('en-US', {
          style: 'decimal',
        });
      }
      if (currentMetric[13] !== '') {
        metrics[key].goal = currentMetric[13].toLocaleString('en-US', {
          style: 'decimal',
        });
      }
      if (currentMetric[8] !== '') {
        metrics[key].lastMetric = currentMetric[8].toLocaleString('en-US', {
          style: 'decimal',
        });
      }
    }

    // mark calculated metrics + group
    if (currentMetric[22] === 'Yes') {
      const grouping = currentMetric[23];

      if (currentMetric[19] === '') {
        universalCalc.push(currentMetric[6]);
      } else if (currentMetric[19] === 'Convert') {
        convertCalc.push(currentMetric[6]);
      } else if (currentMetric[19] === 'Switch') {
        switchCalc.push(currentMetric[6]);
      } else if (currentMetric[19] === 'Subtract') {
        subtractCalc.push(currentMetric[6]);
      }

      calcGroupByMetric[currentMetric[6]] = grouping;
    }

    if (currentMetric[20] === 'Yes' || currentMetric[21] === 'Yes') {
      universalCalcInpDict[currentMetric[6]] = '';
    }
    if (currentMetric[20] === 'Yes') {
      if (universalAttributes[currentMetric[23]] === undefined) {
        universalAttributes[currentMetric[23]] = {
          dividend: '',
          divisor: '',
        };
      }
      universalAttributes[currentMetric[23]].dividend = currentMetric[6];
    }
    if (currentMetric[21] === 'Yes') {
      if (universalAttributes[currentMetric[23]] === undefined) {
        universalAttributes[currentMetric[23]] = {
          dividend: '',
          divisor: '',
        };
      }
      universalAttributes[currentMetric[23]].divisor = currentMetric[6];
    }

    if (currentMetric[19] === 'Display5') {
      showDisabled.push(currentMetric[6]);
      if (businessDayNumber < 1) {
        dispFive.push(currentMetric[6]);
      }
    }
  }

  // Evaluate metrics, inputs into universalCalcInpDict, errors, etc. ---------------------------------
  for (let element in metrics) {
    let metric = metrics[element];

    if (
      !metric.description ||
      metric.description === 'NotRealMetric' ||
      dispFive.includes(metric.description)
    ) {
      continue;
    }

    total += 1;
    totalMetsCat[metric.category] = (totalMetsCat[metric.category] || 0) + 1;

    if (!categoryArray.includes(metric.category)) {
      categoryArray.push(metric.category);
      categoryCompleted[metric.category] = 'Yes';
    }

    if (!metric.metric || metric.metric.length === 0) {
      x += 1;
      nonCompleteCats.push(metric.category);
      missingMetsCat[metric.category] =
        (missingMetsCat[metric.category] || 0) + 1;
    } else {
      let metricNoCommas = metric.metric.toString().replace(/,/g, '');
      let goalWithoutCommas = metric.goal.toString().replace(/,/g, '');
      let r12WithoutCommas = metric.r12m.toString().replace(/,/g, '');
      let metricEl = parseFloat(metricNoCommas);
      let metricGoal = parseFloat(goalWithoutCommas);
      let metricR12 = parseFloat(r12WithoutCommas);

      if (metric.metric === 'Yes') {
        metricEl = -1;
      } else if (metric.metric === 'No') {
        metricEl = 1;
      }

      if (metric.goal === 'Yes') {
        metricGoal = -1;
      } else if (metric.goal === 'No') {
        metricGoal = 1;
      }

      if (lowerGoals.includes(metric.description)) {
        if (metricEl > metricGoal) {
          metric.error = true;
          metric.help = 'Populate RCA';
          metric.disabled = false;

          if (
            metric.rcaRoot.length < 1 ||
            metric.rcaAction.length < 1
          ) {
            rcaCount += 1;
          }
        }
      } else if (metrics[element].adorn === '%' && metricEl > 100) {
        metric.error = true;
        metric.help = 'Over 100 Error';
      } else {
        if (metricEl < metricGoal) {
          metric.error = true;
          metric.help = 'Populate RCA';
          metric.disabled = false;

          if (
            metric.rcaRoot.length < 1 ||
            metric.rcaAction.length < 1
          ) {
            rcaCount += 1;
          }
        } else if (metrics[element].adorn === '%' && metricEl > 100) {
          metric.error = true;
          metric.help = 'Over 100 Error';
        }
      }

      if (Math.abs((metricEl - metricR12) / metricR12) * 100 >= 15) {
        metric.help += ' - 15% Dev. from avg';
      }
    }

    if (Object.keys(universalCalcInpDict).includes(metric.description)) {
      if (metric.metric !== '') {
        let metricNoCommas = metric.metric.toString().replace(/,/g, '');
        if (metricNoCommas !== universalCalcInpDict[metric.description]) {
          universalCalcInpDict[metric.description] = metricNoCommas;
        }
      }
    }
  }

  // Build calculated values + pending posts (no state updates here) -----------------------------------
  const pendingCalcPosts = [];

  const allCalcDescriptions = [
    ...universalCalc,
    ...convertCalc,
    ...switchCalc,
    ...subtractCalc,
  ];

  allCalcDescriptions.forEach((desc) => {
    const metric = metrics[desc];
    if (!metric) return;

    const grouping = calcGroupByMetric[desc];
    const attrs = universalAttributes[grouping];
    if (!attrs) return;

    const rawDividend = universalCalcInpDict[attrs.dividend];
    const rawDivisor = universalCalcInpDict[attrs.divisor];

    let calcVal = '';

    const dividend = parseFloat(rawDividend);
    const divisor = parseFloat(rawDivisor);

    const hasDividend = rawDividend !== '' && !isNaN(dividend);
    const hasDivisor = rawDivisor !== '' && !isNaN(divisor) && divisor !== 0;

    if (hasDividend && hasDivisor) {
      if (universalCalc.includes(desc)) {
        calcVal = ((dividend / divisor) * 100).toFixed(2);
      } else if (convertCalc.includes(desc)) {
        calcVal = (((divisor - dividend) / divisor) * 100).toFixed(2);
      } else if (switchCalc.includes(desc)) {
        const minVal = Math.min(dividend, divisor);
        const maxVal = Math.max(dividend, divisor);
        calcVal = ((minVal / maxVal) * 100).toFixed(2);
      } else if (subtractCalc.includes(desc)) {
        // NEW: Subtract = dividend - divisor (no % scaling)
        calcVal = (dividend - divisor).toFixed(2);
      }
    }

    universalCalcDict[desc] = calcVal;

    const currentRaw =
      metric.metric === '' || metric.metric === null
        ? ''
        : metric.metric.toString().replace(/,/g, '');

    const shouldClear = !hasDivisor; // when divisor missing/0 -> clear DB
    const targetAmount = shouldClear ? '' : calcVal;

    if (targetAmount === '' && currentRaw === '') {
      return;
    }

    if (
      targetAmount !== '' &&
      currentRaw !== '' &&
      Number(targetAmount) === Number(currentRaw)
    ) {
      return;
    }

    pendingCalcPosts.push({
      desc,
      amount: targetAmount,
      adorn: metric.adorn,
    });
  });

  //Hardcoding Net Var Value due to logic and DB restrictions on using multiple inputs for groupings 
  const NET_VAR_DESC = 'Net Var Value';

  if (metrics[NET_VAR_DESC]) {
    const netVarMetric = metrics[NET_VAR_DESC];
    const counted = metrics['Counted Value'];
    const expected = metrics['Expected Value'];

    let calcVal = '';

    if (counted && expected) {
      const countedRaw =
        counted.metric === '' || counted.metric === null
          ? ''
          : counted.metric.toString().replace(/,/g, '');
      const expectedRaw =
        expected.metric === '' || expected.metric === null
          ? ''
          : expected.metric.toString().replace(/,/g, '');

      const countedNum = parseFloat(countedRaw);
      const expectedNum = parseFloat(expectedRaw);

      if (!isNaN(countedNum) && !isNaN(expectedNum)) {
        // straight difference, no percent scaling
        calcVal = (countedNum - expectedNum).toFixed(2);
      }
    }

    // put the value in the same dict used by other calculated metrics
    universalCalcDict[NET_VAR_DESC] = calcVal;

    const currentRaw =
      netVarMetric.metric === '' || netVarMetric.metric === null
        ? ''
        : netVarMetric.metric.toString().replace(/,/g, '');

    const targetAmount = calcVal; // '' if we couldn't compute

    // if both blank, nothing to do
    if (!(targetAmount === '' && currentRaw === '')) {
      // if different, queue a DB post just like other calcs
      if (
        !(
          targetAmount !== '' &&
          currentRaw !== '' &&
          Number(targetAmount) === Number(currentRaw)
        )
      ) {
        pendingCalcPosts.push({
          desc: NET_VAR_DESC,
          amount: targetAmount,
          adorn: netVarMetric.adorn,
        });
      }
    }
  }

  // store pending posts for effect
  pendingCalcPostsRef.current = pendingCalcPosts;

  // After DB data changes, push calculated metrics if needed (no render-loop side effects)
  useEffect(() => {
    const posts = pendingCalcPostsRef.current || [];
    posts.forEach(({ desc, amount, adorn }) => {
      const normalized = amount === '' ? '' : String(amount);
      if (lastPostedCalcRef.current[desc] === normalized) {
        return;
      }
      lastPostedCalcRef.current[desc] = normalized;
      calcMutation.mutate({ desc, amount, adorn });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newMetrics, plant, queryDate]);

  // Build dicts for current category ------------------------------------------------------------------
  for (let cat of nonCompleteCats) {
    categoryCompleted[cat] = 'No';
  }

  if (currCategory !== 0) {
    for (let element in metrics) {
      let metricComp = metrics[element].category;

      if (metricComp === currCategory) {
        if (dispFive.includes(metrics[element].description)) {
          continue;
        }
        metricDict[metrics[element].description] =
          metrics[element].metric;
        let trueFalse = metrics[element].error === true;
        metricErrorDict[metrics[element].description] = trueFalse;
        metricLastDict[metrics[element].description] =
          metrics[element].lastMetric;
        metricHelpDict[metrics[element].description] =
          metrics[element].help;
        metricGoalDict[metrics[element].description] =
          metrics[element].goal;
        metricR12Dict[metrics[element].description] =
          metrics[element].r12m;
        metricAdornDict[metrics[element].description] =
          metrics[element].adorn;
        metricRcaDict[metrics[element].description] =
          metrics[element].rcaRoot;
        metricRcaActionDict[metrics[element].description] =
          metrics[element].rcaAction;
        metricDisabled[metrics[element].description] =
          metrics[element].disabled;
        metricMultiLine[metrics[element].description] = false;
        metricInfoDict[metrics[element].description] =
          metrics[element].info;
      }
    }
  }

  useEffect(() => {
    if (z !== x) {
      setNumOfMetrics(x);
      countMetrics(x);
    }
  }, [x, z, countMetrics]);

  useEffect(() => {
    if (y !== rcaCount) {
      setNumOfRcas(rcaCount);
      countRCAs(rcaCount);
    }
  }, [y, rcaCount, countRCAs]);

  useEffect(() => {
    if (t !== total) {
      setTotalMetCount(total);
    }
  }, [t, totalMetCount, total]);

  const listItems = Object.keys(metricDict).map((key, index) => {
    if (yesNo.includes(key)) {
      return (
        <div
          className="dataDiv"
          key={currCategory + index}
          style={{
            display: 'flex',
            flexDirection: 'column',
            marginTop: 'clamp(20px, 0.5vw, 100px)',
          }}
        >
          <FormLabel component="legend">{key}:</FormLabel>
          <RadioGroup
            className="yesFlex"
            aria-label="choice"
            name={key}
            value={metricDict[key]}
            row
          >
            <FormControlLabel
              value="Yes"
              control={<Radio />}
              label="Yes"
              onChange={handleChange(key)}
            />
            <FormControlLabel
              value="No"
              control={<Radio />}
              label="No"
              onChange={handleChange(key)}
            />
            <InfoIcon
              style={{ fontSize: 'clamp(0.7rem, 1vw, 5rem)' }}
              className="infoIcon"
            />
            <div className="hoverInfo">{metricInfoDict[key]}</div>
          </RadioGroup>
        </div>
      );
    } else if (
      universalCalc.includes(key) ||
      convertCalc.includes(key) ||
      switchCalc.includes(key) ||
      subtractCalc.includes(key) ||
      key === 'Net Var Value' 
    ) {
      // Calculated metrics are read-only and show universalCalcDict value
      return (
        <div
          className="dataDiv"
          key={currCategory + index}
          style={{ display: 'flex' }}
        >
          <TextField
            sx={{ fontSize: 'clamp(0.5rem, 1vw, 10rem)' }}
            className={'textField'}
            InputLabelProps={{
              inputMode: 'numeric',
              pattern: '[0-9]*',
              style: {
                fontSize: 'clamp(0.5rem, 1vw, 5rem)',
              },
            }}
            color="primary"
            variant="standard"
            type="text"
            error={metricErrorDict[key]}
            label={key}
            disabled={true}
            value={universalCalcDict[key] ?? ''}
            helperText={metricHelpDict[key]}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  {metricAdornDict[key]}
                </InputAdornment>
              ),
              style: { fontSize: 'clamp(0.5rem, 1vw, 5rem)' },
            }}
            margin="normal"
            size="small"
          />
          <InfoIcon
            style={{ fontSize: 'clamp(0.7rem, 1vw, 5rem)' }}
            className="infoIcon"
          />
          <div className="hoverInfo">{metricInfoDict[key]}</div>
        </div>
      );
    } else if (showDisabled.includes(key)) {
      return (
        <div
          className="dataDiv"
          key={currCategory + index}
          style={{ display: 'flex' }}
        >
          <TextField
            sx={{ fontSize: 'clamp(0.5rem, 1vw, 10rem)' }}
            className={'textField'}
            InputLabelProps={{
              inputMode: 'numeric',
              pattern: '[0-9]*',
              style: {
                fontSize: 'clamp(0.5rem, 1vw, 5rem)',
              },
            }}
            color="primary"
            variant="standard"
            type="text"
            error={metricErrorDict[key]}
            label={key}
            disabled={true}
            defaultValue={metricDict[key]}
            helperText={metricHelpDict[key]}
            itemProp={{
              style: {
                fontSize: 'clamp(0.5rem, 1vw, 5rem)',
              },
            }}
            inputProps={{
              maxLength: 10,
              inputMode: 'numeric',
              pattern: '[0-9]*',
              style: {
                fontSize: 'clamp(0.5rem, 1vw, 5rem)',
              },
            }}
            InputProps={{
              endAdornment: (
                <div
                  style={{ fontSize: 'clamp(0.5rem, 0.5vw, 5rem)' }}
                >
                  <InputAdornment
                    sx={{
                      fontSize: 'clamp(0.5rem, 0.5vw, 5rem)',
                    }}
                    position="end"
                  >
                    {metricAdornDict[key]}
                  </InputAdornment>
                </div>
              ),
              style: { fontSize: 'clamp(0.5rem, 1vw, 5rem)' },
            }}
            margin="normal"
            size="small"
          />
          <InfoIcon
            style={{ fontSize: 'clamp(0.7rem, 1vw, 5rem)' }}
            className="infoIcon"
          />
          <div className="hoverInfo">{metricInfoDict[key]}</div>
        </div>
      );
    } else {
      return (
        <div
          className="dataDiv"
          key={currCategory + index}
          style={{ display: 'flex' }}
        >
          <TextField
            sx={{ fontSize: 'clamp(0.5rem, 1vw, 10rem)' }}
            className={'textField'}
            InputLabelProps={{
              inputMode: 'numeric',
              pattern: '[0-9]*',
              style: {
                fontSize: 'clamp(0.5rem, 1vw, 5rem)',
              },
            }}
            color="primary"
            variant="standard"
            type="text"
            error={metricErrorDict[key]}
            label={key}
            disabled={disabled}
            defaultValue={metricDict[key]}
            helperText={metricHelpDict[key]}
            itemProp={{
              style: {
                fontSize: 'clamp(0.5rem, 1vw, 5rem)',
              },
            }}
            inputProps={{
              maxLength: 10,
              inputMode: 'numeric',
              pattern: '-?[0-9]*[.,]?[0-9]*',
              style: {
                fontSize: 'clamp(0.5rem, 1vw, 5rem)',
              },
            }}
            onKeyPress={(event) => {
              if (
                acceptable.includes(event?.key) === false ||
                (metricAdornDict[key] === '%' &&
                  parseFloat(event.target.value + event?.key) > 100) ||
                (event.target.value.includes('.') &&
                  event?.key === '.') ||
                (metricAdornDict[key] === '%' &&
                  event?.key === ',')
              ) {
                event.preventDefault();
              }
            }}
            InputProps={{
              endAdornment: (
                <div
                  style={{ fontSize: 'clamp(0.5rem, 0.5vw, 5rem)' }}
                >
                  <InputAdornment
                    sx={{
                      fontSize: 'clamp(0.5rem, 0.5vw, 5rem)',
                    }}
                    position="end"
                  >
                    {metricAdornDict[key]}
                  </InputAdornment>
                </div>
              ),
              style: { fontSize: 'clamp(0.5rem, 1vw, 5rem)' },
            }}
            onBlur={handleBlur(key)}
            margin="normal"
            size="small"
          />
          <InfoIcon
            style={{ fontSize: 'clamp(0.7rem, 1vw, 5rem)' }}
            className="infoIcon"
          />
          <div className="hoverInfo">{metricInfoDict[key]}</div>
        </div>
      );
    }
  });

  const lastListItems = Object.keys(metricLastDict).map((key, index) => {
    return (
      <div
        className="dataDiv"
        key={index}
        style={{ display: 'flex' }}
      >
        <TextField
          className="textField"
          InputLabelProps={{ shrink: true }}
          inputProps={{
            maxLength: 10,
            inputMode: 'numeric',
            pattern: '[0-9]*',
            style: {
              fontSize: 'clamp(0.5rem, 1vw, 5rem)',
            },
          }}
          color="primary"
          variant="filled"
          error={false}
          disabled={true}
          helperText=" "
          value={metricLastDict[key]}
          margin="normal"
          size="small"
        />
      </div>
    );
  });

  const goalListItems = Object.keys(metricGoalDict).map((key, index) => {
    const curr = metricDict[key];
    const goal = metricGoalDict[key];

    const baseProps = {
      className: 'textField',
      InputLabelProps: { shrink: true },
      inputProps: {
        maxLength: 10,
        inputMode: 'numeric',
        pattern: '[0-9]*',
        style: { fontSize: 'clamp(0.5rem, 1vw, 5rem)' },
      },
      color: 'primary',
      variant: 'filled',
      error: false,
      disabled: true,
      helperText: ' ',
      value: goal,
      margin: 'normal',
      size: 'small',
    };

    const yesNoBad =
      (curr === 'Yes' && goal === 'No') ||
      (curr === 'No' && goal === 'Yes');
    const yesNoGood =
      (curr === 'Yes' && goal === 'Yes') ||
      (curr === 'No' && goal === 'No');

    let backgroundColor;

    if (lowerGoals.includes(key)) {
      if (yesNoBad) {
        backgroundColor = 'rgba(255,0,0,0.2)';
      } else if (yesNoGood) {
        backgroundColor = 'rgba(0,128,0,0.2)';
      } else if (
        parseFloat(curr) > parseFloat(goal)
      ) {
        backgroundColor = 'rgba(255,0,0,0.2)';
      } else if (curr > 100 && goal !== '') {
        backgroundColor = 'rgba(255, 165, 0,0.5)';
      } else if (
        parseFloat(curr) <= parseFloat(goal)
      ) {
        backgroundColor = 'rgba(0,128,0,0.2)';
      }
    } else {
      if (yesNoBad) {
        backgroundColor = 'rgba(255,0,0,0.2)';
      } else if (yesNoGood) {
        backgroundColor = 'rgba(0,128,0,0.2)';
      } else if (
        parseFloat(curr) < parseFloat(goal)
      ) {
        backgroundColor = 'rgba(255,0,0,0.2)';
      } else if (curr > 100 && goal !== '') {
        backgroundColor = 'rgba(255, 165, 0,0.5)';
      } else if (
        parseFloat(curr) >= parseFloat(goal)
      ) {
        backgroundColor = 'rgba(0,128,0,0.2)';
      }
    }

    const mergedInputProps = {
      ...baseProps.inputProps,
      style: {
        ...baseProps.inputProps.style,
        ...(backgroundColor ? { backgroundColor } : {}),
      },
    };

    return (
      <div
        className="dataDiv"
        key={'avg' + index}
        style={{ display: 'flex' }}
      >
        <TextField
          {...baseProps}
          inputProps={mergedInputProps}
        />
      </div>
    );
  });

  const r12ListItems = Object.keys(metricR12Dict).map((key, index) => {
    return (
      <div
        className="dataDiv"
        key={'avg' + index}
        style={{ display: 'flex' }}
      >
        <TextField
          className="textField"
          InputLabelProps={{ shrink: true }}
          inputProps={{
            maxLength: 10,
            inputMode: 'numeric',
            pattern: '[0-9]*',
            style: {
              fontSize: 'clamp(0.5rem, 1vw, 5rem)',
            },
          }}
          color="primary"
          variant="filled"
          error={false}
          disabled={true}
          helperText=" "
          value={metricR12Dict[key]}
          margin="normal"
          size="small"
        />
      </div>
    );
  });

  const rcaItems = Object.keys(metricRcaDict).map((key, index) => {
    return (
      <div
        className="dataDiv"
        key={currCategory + index + 'rca'}
        style={{ display: 'flex' }}
      >
        <TextField
          className={'textField'}
          InputLabelProps={{
            style: {
              fontSize: 'clamp(0.5rem, 1vw, 5rem)',
            },
          }}
          color="primary"
          variant="standard"
          type="text"
          error={metricErrorDict[key]}
          multiline
          maxRows={2}
          label={key}
          disabled={metricDisabled[key]}
          defaultValue={metricRcaDict[key]}
          helperText={metricHelpDict[key]}
          inputProps={{
            maxLength: 140,
            style: {
              fontSize: 'clamp(0.5rem, 1vw, 5rem)',
            },
          }}
          onBlur={handleRcaBlur(key)}
          margin="normal"
          size="small"
        />
      </div>
    );
  });

  const rcaItemsAction = Object.keys(metricRcaActionDict).map(
    (key, index) => {
      return (
        <div
          className="dataDiv"
          key={currCategory + index + 'rcaAction'}
          style={{ display: 'flex' }}
        >
          <TextField
            className={'textField'}
            InputLabelProps={{
              style: {
                fontSize: 'clamp(0.5rem, 1vw, 5rem)',
              },
            }}
            color="primary"
            variant="standard"
            type="text"
            error={metricErrorDict[key]}
            multiline={true}
            maxRows={2}
            label={key}
            disabled={metricDisabled[key]}
            defaultValue={metricRcaActionDict[key]}
            helperText={metricHelpDict[key]}
            inputProps={{
              maxLength: 140,
              style: {
                fontSize: 'clamp(0.5rem, 1vw, 5rem)',
              },
            }}
            onBlur={handleRcaActionBlur(key)}
            margin="normal"
            size="small"
          />
        </div>
      );
    }
  );

  if (dbQuery.isLoading)
    return (
      <div className="loadWalk">
        <NewSideCube
          front={
            <Box sx={{ p: 2 }}>
              <div className="sideCubeFont">LOADING...</div>
              <DownloadingIcon
                sx={{ fontSize: 'clamp(1rem, 1vw, 10rem)' }}
              />
            </Box>
          }
          back={
            <Box sx={{ p: 2 }}>
              <div className="sideCubeFont">LOADING...</div>
              <HourglassTopIcon
                sx={{ fontSize: 'clamp(1rem, 1vw, 10rem)' }}
              />
            </Box>
          }
          left={
            <Box sx={{ p: 2 }}>
              <div className="sideCubeFont">LOADING...</div>
              <DownloadingIcon
                sx={{ fontSize: 'clamp(1rem, 1vw, 10rem)' }}
              />
            </Box>
          }
          right={
            <Box sx={{ p: 2 }}>
              <div className="sideCubeFont">LOADING...</div>
              <HourglassTopIcon
                sx={{ fontSize: 'clamp(1rem, 1vw, 10rem)' }}
              />
            </Box>
          }
          top={
            <Box sx={{ p: 2 }}>
              <div className="sideCubeFont">LOADING...</div>
              <DownloadingIcon
                sx={{ fontSize: 'clamp(1rem, 1vw, 10rem)' }}
              />
            </Box>
          }
          bottom={
            <Box sx={{ p: 2 }}>
              <div className="sideCubeFont">LOADING...</div>
              <HourglassTopIcon
                sx={{ fontSize: 'clamp(1rem, 1vw, 10rem)' }}
              />
            </Box>
          }
        />
      </div>
    );

  if (dbQuery.isError)
    return (
      <pre className="redError">
        Oops something went wrong please return to{' '}
        <a href="https://metrics.logistics.coty.com/">homepage</a>
      </pre>
    );

  return (
    <>
      {isFirstDay && isOpen && newMetrics.length === 0 && (
        <div className="overlayNew">
          <button className="close-buttonNew" onClick={handleClose}>
            X
          </button>
          <h3>
            Metrics for the new month entry will be available after
            Midnight Eastern Standard Time on the 1st of the month.
            Please check back then, if no categories display after
            loading is complete!
          </h3>
        </div>
      )}
      <h4 className="dateFixMet">
  {currCategory === 'SCLT_Weekly'
    ? weeklyHeader
    : `${dateDict[month]} ${currYear}`}
</h4>



      <div className="metricLoader">
        <div className="labsNav1">
          <div className="logoContain">
            <Link className="linkFlex" to="/">
              <h1>C O T Y</h1>
            </Link>
          </div>

          <div className="help">
            <div className="muiButtons">
              <div className="homeMui">
                <a
                  href="https://metrics.logistics.coty.com"
                  title="Home"
                >
                  <HomeIcon />
                </a>
              </div>
              <div className="change">
                <a
                  href="https://forms.office.com/r/PqdttMbugi"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="ChangeRequest"
                >
                  <ArticleIcon />
                </a>
              </div>
              <div
                className="contactUs"
                onClick={() => {
                  window.location.href =
                    'mailto:Logistics_Data@cotyinc.com?subject=KPI%20Metric%20Request';
                }}
                title="Contact Us"
              >
                <HelpIcon />
              </div>
            </div>
          </div>
        </div>

        <div className="stoplight-container">
          <div
            className="stoplight-light"
            style={{
              backgroundColor: colors[currentColorIndex],
            }}
          >
            <div className="stoplight-label">
              {currentColorIndex === 0 &&
                `${(
                  ((totalMetCount - numOfMetrics) / totalMetCount) *
                  100
                ).toFixed(2)}% Complete`}
              {currentColorIndex === 1 &&
                `Incomplete RCAS ${numOfRcas}`}
              {currentColorIndex === 2 &&
                `Metrics Left ${numOfMetrics}`}
            </div>
          </div>
        </div>

        <div className="cubeLeftTwo">
          <NewSideCube
            front={
              <Box sx={{ p: 2 }}>
                <div className="sideCubeFont">Actionable Data</div>
                <DatasetIcon
                  sx={{ fontSize: 'clamp(1rem, 1vw, 10rem)' }}
                />
              </Box>
            }
            back={
              <Box sx={{ p: 2 }}>
                <div className="sideCubeFont">Fast Processing</div>
                <SpeedIcon
                  sx={{ fontSize: 'clamp(1rem, 1vw, 10rem)' }}
                />
              </Box>
            }
            left={
              <Box sx={{ p: 2 }}>
                <div className="sideCubeFont">Optimal Decisions</div>
                <PendingActionsIcon
                  sx={{ fontSize: 'clamp(1rem, 1vw, 10rem)' }}
                />
              </Box>
            }
            right={
              <Box sx={{ p: 2 }}>
                <div className="sideCubeFont">Increased Efficiency</div>
                <ThumbUpOffAltIcon
                  sx={{ fontSize: 'clamp(1rem, 1vw, 10rem)' }}
                />
              </Box>
            }
            top={
              <Box sx={{ p: 2 }}>
                <div className="sideCubeFont">Real Time Results</div>
                <AccessTimeIcon
                  sx={{ fontSize: 'clamp(1rem, 1vw, 10rem)' }}
                />
              </Box>
            }
            bottom={
              <Box sx={{ p: 2 }}>
                <div className="sideCubeFont">Easy to Use</div>
                <ElectricBoltIcon
                  sx={{ fontSize: 'clamp(1rem, 1vw, 10rem)' }}
                />
              </Box>
            }
          />
        </div>

        <div className="loadMets">
          <div></div>
          <div className="formHeaderSect">
            <div className="arrowFlex">
              <div
                className="metricLeft"
                style={{
                  color:
                    numOfMetrics > 0
                      ? 'rgba(255, 0, 0, 0.7)'
                      : 'rgba(0, 37, 84, 1)',
                }}
              ></div>
              <div className="plantName">
                <div className="centerThis">
                  <h1>
                    {plantDictionary[plant] &&
                      plantDictionary[plant].toUpperCase()}
                  </h1>
                </div>
              </div>
              <div
                className="rcaIncomplete"
                style={{
                  color:
                    numOfRcas > 0
                      ? 'rgba(255, 0, 0, 0.7)'
                      : 'rgba(0, 37, 84, 1)',
                }}
              ></div>
            </div>
            <div
              className="flexCatTwo"
              style={{
                opacity: plant === 'none' ? '0' : '1',
              }}
            >
              <ArrowCircleLeftIcon
                className="arrow"
                onClick={() => moveCat('minus')}
              />
              {categoryArray.map((category, i) => (
                <div
                  key={i}
                  className="categoryTwo"
                  style={{
                    color:
                      categoryCompleted[category] === 'Yes'
                        ? 'rgba(0, 128, 0, 0.7)'
                        : 'rgba(0, 37, 84, 0.9)',
                    border:
                      currCategory === category
                        ? '1px solid #002254'
                        : 'none',
                  }}
                  onClick={() => updateCat({ category })}
                >
                  {mui[category]}{' '}
                  <div className="overlay">{category}</div>
                  <div className="overlay">
                    {totalMetsCat[category] -
                      (missingMetsCat[category] || 0)}
                    /{totalMetsCat[category]}
                  </div>
                </div>
              ))}
              <ArrowCircleRightIcon
                className="arrow"
                onClick={() => moveCat('plus')}
              />
            </div>
          </div>

          <div className="flexForms" ref={containerRef}>
            <div className="metricList">
              <form
                className="formFlex"
                autoComplete="off"
                style={{
                  display:
                    postMutation.status === 'error' ||
                    calcMutation.status === 'error'
                      ? 'none'
                      : 'flex',
                }}
              >
                <div className="flexDiv">
                  <h5
                    className="monthLabels"
                    style={{
                      display:
                        currCategory === 0 ? 'none' : 'flex',
                    }}
                  >
                    Enter Metrics
                  </h5>
                </div>
                {listItems}
              </form>
              <h4
                className="errorRed"
                style={{
                  display:
                    postMutation.status === 'error' ||
                    calcMutation.status === 'error'
                      ? 'block'
                      : 'none',
                }}
              >
                Oops something went wrong please return to{' '}
                <a href="https://metrics.logistics.coty.com/">
                  homepage
                </a>
              </h4>
            </div>

            <div className="metricList combo">
              <form
                className="formFlex third prevMth"
                autoComplete="off"
              >
                <div className="flexDiv monthLabels prevMth">
                  <h5
                    style={{
                      display:
                        currCategory === 0 ? 'none' : 'flex',
                    }}
                  >
                    PrvMth
                  </h5>
                </div>
                {lastListItems}
              </form>
              <form
                className="formFlex third goal"
                autoComplete="off"
              >
                <div className="flexDiv monthLabels goal">
                  <h5
                    style={{
                      display:
                        currCategory === 0 ? 'none' : 'flex',
                    }}
                  >
                    Goal
                  </h5>
                </div>
                {goalListItems}
              </form>
              <form
                className="formFlex third goal"
                autoComplete="off"
              >
                <div className="flexDiv monthLabels goal">
                  <h5
                    style={{
                      display:
                        currCategory === 0 ? 'none' : 'flex',
                    }}
                  >
                    12MthAvg
                  </h5>
                </div>
                {r12ListItems}
              </form>
            </div>

            <div className="metricList">
              <form
                className="formFlex"
                autoComplete="off"
                style={{
                  display:
                    rcaMutation.status === 'error'
                      ? 'none'
                      : 'flex',
                }}
              >
                <div className="flexDiv monthLabels">
                  <h5
                    style={{
                      display:
                        currCategory === 0 ? 'none' : 'flex',
                    }}
                  >
                    Root Cause
                  </h5>
                </div>
                {rcaItems}
              </form>
              <h4
                className="errorRed"
                style={{
                  display:
                    rcaMutation.status === 'error'
                      ? 'block'
                      : 'none',
                }}
              >
                Oops something went wrong please return to{' '}
                <a href="https://metrics.logistics.coty.com/">
                  homepage
                </a>
              </h4>
            </div>

            <div className="metricList">
              <form
                className="formFlex"
                autoComplete="off"
                style={{
                  display:
                    rcaActionMutation.status === 'error'
                      ? 'none'
                      : 'flex',
                }}
              >
                <div className="flexDiv monthLabels">
                  <h5
                    style={{
                      display:
                        currCategory === 0 ? 'none' : 'flex',
                    }}
                  >
                    Action Plan
                  </h5>
                </div>
                {rcaItemsAction}
              </form>
              <h4
                className="errorRed"
                style={{
                  display:
                    rcaActionMutation.status === 'error'
                      ? 'block'
                      : 'none',
                }}
              >
                Oops something went wrong please return to{' '}
                <a href="https://metrics.logistics.coty.com/">
                  homepage
                </a>
              </h4>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default MetricLoader;
